import { SVGProps } from "react";

export const LoadingOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_165_978)">
      <path
        d="M8 16C6.92031 16 5.87188 15.7891 4.88594 15.3719C3.93281 14.9688 3.07813 14.3906 2.34375 13.6562C1.60938 12.9219 1.03125 12.0672 0.628125 11.1141C0.210938 10.1281 0 9.07969 0 8C0 7.68906 0.251563 7.4375 0.5625 7.4375C0.873438 7.4375 1.125 7.68906 1.125 8C1.125 8.92813 1.30625 9.82812 1.66563 10.6766C2.0125 11.4953 2.50781 12.2312 3.13906 12.8625C3.77031 13.4938 4.50625 13.9906 5.325 14.3359C6.17188 14.6938 7.07188 14.875 8 14.875C8.92813 14.875 9.82813 14.6938 10.6766 14.3344C11.4953 13.9875 12.2313 13.4922 12.8625 12.8609C13.4938 12.2297 13.9906 11.4938 14.3359 10.675C14.6938 9.82812 14.875 8.92813 14.875 8C14.875 7.07188 14.6938 6.17188 14.3344 5.32344C13.9887 4.50665 13.4884 3.76439 12.8609 3.1375C12.2347 2.50925 11.4923 2.0088 10.675 1.66406C9.82813 1.30625 8.92813 1.125 8 1.125C7.68906 1.125 7.4375 0.873438 7.4375 0.5625C7.4375 0.251563 7.68906 0 8 0C9.07969 0 10.1281 0.210938 11.1141 0.628125C12.0672 1.03125 12.9219 1.60938 13.6563 2.34375C14.3906 3.07812 14.9672 3.93438 15.3703 4.88594C15.7875 5.87188 15.9984 6.92031 15.9984 8C15.9984 9.07969 15.7875 10.1281 15.3703 11.1141C14.9688 12.0672 14.3906 12.9219 13.6563 13.6562C12.9219 14.3906 12.0656 14.9672 11.1141 15.3703C10.1281 15.7891 9.07969 16 8 16Z"
        fill={"currentColor"}
      />
    </g>
    <defs>
      <clipPath id="clip0_165_978">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
